// src/pages/restaurant-tables/ContinentalTables.jsx
import React from 'react';
import LocationTables from '../LocationTables';

const ContinentalTables = () => {
  return <LocationTables locationKey="continental" />;
};

export default ContinentalTables;